import React from 'react';
import './ReactGateway/Gateway.js';
import { GatewayDest } from './ReactGateway/GatewayDest.js';
import { GatewayProvider } from './ReactGateway/GatewayProvider.js';
import { OrderedLayers } from './constants.js';
import { TransitionGroup } from 'react-transition-group';
import { getZIndexFromLayer } from './utils.js';
import styled from 'styled-components';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/*
 * ChildrenContainer creates a new stacking context
 * by giving a position other than auto and a z-index.
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
 */

var ChildrenContainer = styled.div.withConfig({
  displayName: "LayerManager__ChildrenContainer",
  componentId: "sc-1k2ulq-0"
})(["position:relative;z-index:0;"]);
/*
 * GatewayLayer styling allows each layer container
 * to stack on top of each other; by default, when
 * no content is in the layer, it does not block clicks
 * (due to the pointer-events none declaration). Any
 * content that renders within the container gets the
 * clicks because pointer-events are reset.
 */

var GatewayLayer = styled(TransitionGroup).withConfig({
  displayName: "LayerManager__GatewayLayer",
  componentId: "sc-1k2ulq-1"
})(["position:fixed;top:0;left:0;height:100%;width:100%;pointer-events:none;> *{pointer-events:auto;}"]); // Due to the legacy `innerRef` usage from `react-gateway`, we
// need to include this wrapper to properly pass through expected
// prop structure for refs in `GatewayDest`. Moving away from
// `react-gateway` to a more modern portals approach will remove
// the need for this stop-gap solution.
// eslint-disable-next-line react/prop-types

var GatewayLayerForwardedInnerRef = function GatewayLayerForwardedInnerRef(_ref) {
  var innerRef = _ref.innerRef,
      props = _objectWithoutProperties(_ref, ["innerRef"]);

  return /*#__PURE__*/React.createElement(GatewayLayer, _extends({
    ref: innerRef
  }, props));
};

var LayerManager = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(LayerManager, _React$PureComponent);

  var _super = _createSuper(LayerManager);

  function LayerManager() {
    _classCallCheck(this, LayerManager);

    return _super.apply(this, arguments);
  }

  _createClass(LayerManager, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return /*#__PURE__*/React.createElement(GatewayProvider, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ChildrenContainer, null, children), OrderedLayers.map(function (layer) {
        return /*#__PURE__*/React.createElement(GatewayDest, {
          component: GatewayLayerForwardedInnerRef // these legacy bits were not cooperating
          ,
          key: layer,
          name: layer // Apparently this prop isn't part of the vendor type
          // ignoring for now as this is pretty legacy stuff that we will be redoing
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          ,
          style: {
            zIndex: getZIndexFromLayer(layer)
          }
        });
      })));
    }
  }]);

  return LayerManager;
}(React.PureComponent);

export { LayerManager as default };
